import {formatCurrency} from '../../../utils';
import AccountSelect from '../../../components/common/AccountSelect';

const TransferForm = ({form, onChange, accounts, editId, onSubmit, onCancel, saving}) => {
    const set = (key, val) => onChange({...form, [key]: val});

    const sentAmount = Number(form.amount) || 0;
    const loss = Number(form.transferLoss) || 0;
    const receivedSameCurrency = sentAmount - loss;

    const canSubmit = form.accountId && form.transferAccountId &&
        form.accountId !== form.transferAccountId &&
        form.amount && form.currencyCode && form.occurredOn &&
        (!form.differentCurrency || (form.transferCurrencyCode && form.transferAmount));

    return (
        <form className="tx-form" onSubmit={(e) => { e.preventDefault(); if (canSubmit) onSubmit(); }}>
            <h3 className="tx-form__title">{editId ? 'Edit Transfer' : 'Add Transfer'}</h3>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Date</label>
                    <input className="tx-form__input" type="date" value={form.occurredOn}
                           onChange={e => set('occurredOn', e.target.value)} required/>
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">Currency</label>
                    <input className="tx-form__input" placeholder="EUR" maxLength={3}
                           value={form.currencyCode}
                           onChange={e => set('currencyCode', e.target.value.toUpperCase())} required/>
                </div>
            </div>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">From account</label>
                    <AccountSelect
                        accounts={accounts}
                        value={form.accountId}
                        onChange={v => set('accountId', v)}
                    />
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">To account</label>
                    <AccountSelect
                        accounts={accounts}
                        value={form.transferAccountId}
                        onChange={v => set('transferAccountId', v)}
                        excludeId={form.accountId}
                    />
                </div>
            </div>

            <div className="tx-form__row">
                <div className="tx-form__field">
                    <label className="tx-form__label">Amount sent</label>
                    <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                           value={form.amount} onChange={e => set('amount', e.target.value)} required/>
                </div>
                <div className="tx-form__field">
                    <label className="tx-form__label">FX loss <span className="tx-form__optional">(optional)</span></label>
                    <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                           value={form.transferLoss} onChange={e => set('transferLoss', e.target.value)}/>
                </div>
            </div>

            {!form.differentCurrency && sentAmount > 0 && (
                <div className="tx-form__preview">
                    <span>Received: <strong>{formatCurrency(receivedSameCurrency, form.currencyCode || 'EUR')}</strong>
                        {loss > 0 && <span className="tx-form__preview-hint"> ({formatCurrency(sentAmount, form.currencyCode)} − {formatCurrency(loss, form.currencyCode)} loss)</span>}
                    </span>
                </div>
            )}

            <label className="tx-form__checkbox-label">
                <input type="checkbox" checked={form.differentCurrency}
                       onChange={e => set('differentCurrency', e.target.checked)}/>
                Different destination currency
            </label>

            {form.differentCurrency && (
                <div className="tx-form__row">
                    <div className="tx-form__field">
                        <label className="tx-form__label">Received currency</label>
                        <input className="tx-form__input" placeholder="USD" maxLength={3}
                               value={form.transferCurrencyCode}
                               onChange={e => set('transferCurrencyCode', e.target.value.toUpperCase())} required/>
                    </div>
                    <div className="tx-form__field">
                        <label className="tx-form__label">Amount received</label>
                        <input className="tx-form__input" type="number" step="0.01" placeholder="0.00"
                               value={form.transferAmount}
                               onChange={e => set('transferAmount', e.target.value)} required/>
                    </div>
                </div>
            )}

            <div className="tx-form__field">
                <label className="tx-form__label">Notes <span className="tx-form__optional">(optional)</span></label>
                <textarea className="tx-form__input tx-form__textarea" value={form.notes}
                          onChange={e => set('notes', e.target.value)} rows={2}/>
            </div>

            <div className="tx-form__actions">
                <button type="button" className="tx-form__btn" onClick={onCancel}>Cancel</button>
                <button type="submit" className="tx-form__btn tx-form__btn--primary"
                        disabled={!canSubmit || saving}>
                    {saving ? 'Saving…' : editId ? 'Save' : 'Add Transfer'}
                </button>
            </div>
        </form>
    );
};

export default TransferForm;
